module.exports = __webpack_public_path__ + "img/qualityJewellery@2x.77ecb3b.jpg";